import { Chip } from "@mui/material";
import { Link, ErrorOutline } from "@mui/icons-material";

interface Props {
  connected: boolean;
}

/**
 * A simple indicator of whether or not an OAuth provider is connected
 */
export const IntegrationConnectedIndicator = (props: Props) => {
  const { connected } = props;
  const text = connected ? " Connected " : " Not Connected ";
  const statusColor = connected ? "success.main" : "error.main";
  const icon = connected ? <Link /> : <ErrorOutline />;

  return (
    <Chip
      icon={icon}
      label={text}
      variant="outlined"
      sx={{
        borderColor: statusColor,
        fontWeight: 600,
        color: "text.primary",
        "& .MuiChip-icon": { color: statusColor },
      }}
    />
  );
};
